
export const IframeOnloadDirective = () => {
    return {
        scope: {
            callBack: '&iframeOnload'
        },
        link: function(scope, element, attrs){
            element.on('load', function(){
                scope.callBack();
            });
        }
    };
}